// Where the site's data comes from: `GET /api/credits` (DIRECTION D1, B-592).
//
// One read the whole page shares (`readStore.ts`), asked by the credits page
// and by each short credit where numbers are shown. It is the same for
// everybody until the next deploy, and the server says so in its cache header.

import { CreditsView, valueOf, type CreditLine } from '@fsp/domain';
import { useRead, type Read } from './read';

export function useCredits(): Read<CreditsView | null> {
  return useRead('/credits', CreditsView);
}

/** The lines once they have arrived, or none while they have not. */
export function useCreditLines(): CreditLine[] {
  return valueOf(useCredits().snapshot)?.lines ?? [];
}
